/** @jsxImportSource @emotion/react */
import React from 'react';
import { FiX } from 'react-icons/fi';

import { Container, Icon, Input, ClearButton } from './search-bar.styled';

import { useSimpleSearchBar, SimpleSearchBarProps } from './search-bar.hooks';

const SimpleSearchBar: React.FC<SimpleSearchBarProps> = (props) => {
  const { onActiveChange, onSearchChange, placeholder } = props;

  const {
    value,
    focused,
    inputRef,
    handleChange,
    handleFocus,
    handleBlur,
    handleKeyDown,
    handleClearMouseDown,
    handleClearClick,
  } = useSimpleSearchBar({ onActiveChange, onSearchChange, placeholder });

  return (
    <Container focused={focused}>
      <Icon>
        <img src="/magnifying-glass.svg" width={24} alt="Search" />
      </Icon>

      <Input
        ref={inputRef}
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder={placeholder ? placeholder : 'Search conversations or notes'}
      />

      {(focused || value.trim()) && (
        <ClearButton
          type="button"
          onMouseDown={handleClearMouseDown}
          onClick={handleClearClick}
          aria-label="Clear search"
        >
          <FiX size={24} color="#B7BDCB" />
        </ClearButton>
      )}
    </Container>
  );
};

export default SimpleSearchBar;
